"use strict";
// @ts-ignore
try {
    self['workbox:recipes:6.1.5'] && _();
}
catch (e) { }
